export default function buildAccountHeader(rawS) {
   return {
      name: rawS._type,
      props: {},
   };
}
